








































































































import { Component, Vue } from "vue-property-decorator";
import { PowerPlan } from "@/services/powerPlans/types";
import { powerPlanFields } from "@/components/powerPlans/fields/powerPlanFields";
import { getPowerPlans, checkDelete, copyPowerPlan } from "@/services/powerPlans/powerPlanService";
import PowerPlanDeleteModal from "@/components/powerPlans/modals/PowerPlanDeleteModal.vue";
import PowerPlanDeleteNotAllowedModal from "@/components/powerPlans/modals/PowerPlanDeleteNotAllowedModal.vue";
@Component({
    components: {
        PowerPlanDeleteModal,
        "power-plan-delete-not-allowed-modal": PowerPlanDeleteNotAllowedModal
    }
})
export default class PowerPlans extends Vue {
        powerPlans = [] as PowerPlan[];
        fields = powerPlanFields;
        isBusy = false;
        sortBy = "name";
        sortDesc = false;
        searchQuery = "";
        // lifecycle hooks
        mounted() {
            this.fetchData();
        }

        // computed
        get filteredData(): Array<PowerPlan> {
            return this.powerPlans.filter(
                x =>
                    this.searchQuery.length === 0 ||
                        x.name.toLowerCase().includes(this.searchQuery.toLowerCase())
            );
        }

        // methods
        fetchData() {
            this.isBusy = true;
            getPowerPlans().then(response => {
                this.powerPlans = response;
                this.isBusy = false;
            });
        }

        copyPowerPlan(id: string) {
            copyPowerPlan(id).then(() => this.fetchData());
        }

        deletePowerPlan(powerPlanId: string, powerPlanName: string) {
            checkDelete(powerPlanId).then(response => {
                if (response.length > 0) {
                    (this.$refs.powerPlanDeleteNotAllowedModal as any).open(response);
                    return;
                }
                (this.$refs.powerPlanDeleteModal as any).open(powerPlanId, powerPlanName);
            });
        }
}
